import React, {useState, useCallback} from "react";
import Sort from '../../../common/enums/Sort.enums'
import {getPanggoList} from "@common/services/restapi/panggo";
import useFetch from "@common/hooks/fetch/useFetch";
import {Moments} from "@common/utils/date/moments";
import BackdropHandler from "../component/BackDropHandler";
import YouTube from "react-youtube";
import Prev from "../../assets/image/icon_prev.svg";
import {useHistory} from "react-router-dom";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const SORT_LIST = [Sort.wdate, Sort.acount];

function PangoList() {

  const history = useHistory();

  const [panggoSearch, SetPanggoSearch] = useState({});
  const {data: panggoList} = useFetch(() => getPanggoList(panggoSearch), [panggoSearch], {});

  const [pangoID, setPangoID] = useState('')

  const showEachPangoVideo = (clickedVideo) => {
    setPangoID(clickedVideo.videoId)
  }

  const opts = {
    height: '300px',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const onReady = (event) => {
    event.target.pauseVideo();
  }

  const handleGoBack = useCallback(() => {
    history.goBack();
  },[]);

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">팡고 TV</h3>
      </div>

      <section className="common-body--list">
        <div className="ad-list pango">
          {panggoList && panggoList.items && panggoList.items.map((eachData, i) => {
              return (
                eachData &&
                  <div className="ad-box small-horizontal" key={`ad-${eachData.snippet.channelId}`} onClick={() => showEachPangoVideo(eachData.id)} key={`panggo-${i}`}>
                    <div className="thumbnail-card-wrapper">
                      <LazyLoadImage className="thumbnail-card small-video" src={`${eachData.snippet.thumbnails.high['url'].replace("http:", "https:")}`}/>
                    </div>
                    <div className="ad-info">
                      <div className="left-box">
                        <h4 className="title">{eachData.snippet.title}</h4>
                        <h5 className="company">{eachData.snippet.channelTitle}</h5>
                        <div className="row-box">
                          <div className="created-date">{Moments.Format(eachData.snippet.publishedAt, 'yyyy.MM.DD')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
              )
            }
          )}
        </div>
        {
          pangoID &&
          <BackdropHandler onClick={() => setPangoID('')}>
            <YouTube videoId={pangoID} opts={opts} iframeClassName="pangoYoutube" onReady={() => onReady}/>
          </BackdropHandler>
        }
      </section>
    </>
  )
}

export default PangoList;
